import { create } from "zustand";
import { createTrackedSelector } from "react-tracked";
import { devtools, persist } from "zustand/middleware";
//SOME STORE KEYS ARE SET DYAMICALLY
import Settings from "../dependencies/custom/settings";

const AUTH_STATE_DEFAULTS = {
  loggedInUser: "",
  permitted_routes: [],
  pages: [],
  tables_metadata: [],
  user: {},
  admissions: [],
  permissions: [],
  roles: [],
  myRoles: [],
};

const AUTH_STORAGE_KEYS = [
  "access",
  "refresh",
  ...Object.keys(AUTH_STATE_DEFAULTS),
];

const store = (set, get) => ({
  loggedInUser: "", //user email @ chat
  phoneWidthBreakPoint: 700,
  permitted_routes: [], //admin/home.js,
  pages: [],
  tables_metadata: [], //@bootstrap @ app.js
  [Settings.storeKeys.DRAWER_STATE]: false,
  // subjects: [
  //     { id: 1, subject: 'Maths', for_interview: 1 },
  //     { id: 2, subject: 'English', for_interview: 1 },
  //     { id: 3, subject: 'Science', for_interview: 0 },
  //     { id: 4, subject: 'Social Studies', for_interview: 0 },
  // ],
  // DRAFT,SUBMITTED,VERIFIED,INTERVIEW,REJECTED,ADMITTED

  // klass_status_transitions: [
  //     // { id: 1, klass: 'Nursery 1', klass_id: 1, current_status: 'SUBMITTED', can_change_to: 'VERIFIED' },
  //     // { id: 2, klass: 'Nursery 2', klass_id: 2, current_status: 'SUBMITTED', can_change_to: 'DRAFT' },
  //     { id: 3, klass: 'Primary 3', klass_id: 3, current_status: 'SUBMITTED', can_change_to: 'DRAFT' },
  //     { id: 4, klass: 'Primary 3', klass_id: 3, current_status: 'SUBMITTED', can_change_to: 'REVIEWED' },
  //     { id: 3, klass: 'Primary 3', klass_id: 3, current_status: 'SUBMITTED', can_change_to: 'INTERVIEW' },

  //     { id: 3, klass: 'Primary 3', klass_id: 3, current_status: 'REVIEWED', can_change_to: 'DRAFT' },
  //     { id: 4, klass: 'Primary 3', klass_id: 3, current_status: 'REVIEWED', can_change_to: 'SUBMITTED' },
  //     { id: 3, klass: 'Primary 3', klass_id: 3, current_status: 'REVIEWED', can_change_to: 'INTERVIEW' },

  //     // { id: 3, klass: 'Primary 3', klass_id: 3, current_status: 'SUBMITTED', can_change_to: 'ADMITTED' },
  //     { id: 4, klass: 'Nursery 1', klass_id: 1, current_status: 'SUBMITTED', can_change_to: 'DRAFT' },
  //     { id: 3, klass: 'Nursery 1', klass_id: 1, current_status: 'SUBMITTED', can_change_to: 'VERIFIED' },
  //     { id: 4, klass: 'Nursery 1', klass_id: 1, current_status: 'SUBMITTED', can_change_to: 'SUBMITTED' }
  // ],

  // statuses: [
  //     { id: 1, status: 'DRAFT', lock_form: 0, show_score_btn: 0 },
  //     { id: 2, status: 'SUBMITTED', lock_form: 1, show_score_btn: 0 },
  //     { id: 3, status: 'INTERVIEW', lock_form: 1, show_score_btn: 1 },
  //     { id: 3, status: 'REVIEWED', lock_form: 1, show_score_btn: 1 }
  // ],

  // school_classes: [
  //     { name: 'Primary 1', id: 1 },
  //     { name: 'Primary 2', id: 2 },
  //     { name: 'Primary 3', id: 3 },
  //     { name: 'Primary 4', id: 4 },
  //     { name: 'Primary 5', id: 5 },
  //     { name: 'Primary 6', id: 6 },
  //     { name: 'JHS 1', id: 7 },
  // ],
  settings: [
    {
      id: 1,
      property: "Date_Format",
      value: "DD/MM/YYYY",
      is_public: 1,
      group: null,
      description: null,
    },
  ],

  // pages: [{
  //     name: 'my_reports',
  //     custom_name: 'Academic Report',
  //     route: '/applicant/my_reports',
  //     parent: null,
  //     order: 1,
  //     icon: 'fas fa-file-alt',
  //     parent_icon: null,
  //     display: 1,
  // },{
  //     name: 'my_attendance',
  //     custom_name: 'Attendance Report',
  //     route: '/applicant/my_attendance',
  //     parent: null,
  //     order: 1,
  //     icon: 'fas fa-calendar',
  //     parent_icon: null,
  //     display: 1,
  // }],

  /*pages: [         
        //  {
        //     name: 'upload',
        //     custom_name: 'Upload',
        //     route: '/admin/upload',
        //     parent: null,
        //     order: 1,
        //     icon: 'fas fa-upload',
        //     parent_icon: null,
        //     display: 0,
        // },
        // {
        //     name: 'my_applications',
        //     custom_name: 'Student Application',
        //     route: '/applicant/my_applications',
        //     parent: null,
        //     order: 1,
        //     icon: 'fas fa-home',
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'my_transport',
        //     custom_name: 'My Transport',
        //     route: '/applicant/my_transport',
        //     parent: null,
        //     order: 1,
        //     icon: 'fa fa-car',
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'users',
        //     custom_name: 'Users',
        //     route: '/admin/users',
        //     parent: 'User Management',
        //     order: 9,
        //     icon: null,
        //     parent_icon: 'fas fa-users',
        //     display: 1,
        // },
        // {
        //     name: 'roles',
        //     custom_name: 'Roles',
        //     route: '/admin/roles',
        //     parent: 'User Management',
        //     order: 9,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'pages',
        //     custom_name: 'Pages',
        //     route: '/admin/pages',
        //     parent: 'User Management',
        //     order: 9,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'permissions',
        //     custom_name: 'Permissions',
        //     route: '/admin/permissions',
        //     parent: 'User Management',
        //     order: 9,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'userRoles',
        //     custom_name: 'User Roles',
        //     route: '/admin/user_roles',
        //     parent: 'User Management',
        //     order: 9,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'rolePermissions',
        //     custom_name: 'Role Permissions',
        //     route: '/admin/role_permissions',
        //     parent: 'User Management',
        //     order: 9,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'rolePages',
        //     custom_name: 'Role Pages',
        //     route: '/admin/role_pages',
        //     parent: 'User Management',
        //     order: 9,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },

        // {
        //     name: 'relationship',
        //     custom_name: 'Relationship',
        //     route: '/admin/relationship',
        //     parent: 'Setup',
        //     order: 3,
        //     icon: null,
        //     parent_icon: 'fas fa-tools',
        //     display: 1,
        // },
        // {
        //     name: 'bootstrap',
        //     custom_name: 'Bootstrap',
        //     route: '/admin/bootstrap',
        //     parent: 'Setup',
        //     order: 3,
        //     icon: null,
        //     parent_icon: 'fas fa-tools',
        //     display: 0,
        // },


        {
            name: 'admission_status',
            custom_name: 'Admission Status',
            route: '/admin/admission_status',
            parent: 'Setup',
            order: 3,
            icon: null,
            parent_icon: 'fas fa-tools',
            display: 1,
        },
        {
            name: 'status_transition',
            custom_name: 'Status Transitions',
            route: '/admin/status_transition',
            parent: 'Setup',
            order: 3,
            icon: null,
            parent_icon: null,
            display: 1,
        },
        {
            name: 'nationality',
            custom_name: 'Nationality',
            route: '/admin/nationality',
            parent: 'Setup',
            order: 3,
            icon: null,
            parent_icon: 'fas fa-tools',
            display: 1,
        },
        {
            name: 'subjects',
            custom_name: 'Subjects',
            route: '/admin/subjects',
            parent: 'Setup',
            order: 3,
            icon: null,
            parent_icon: null,
            display: 1,
        },
        {
            name: 'classes',
            custom_name: 'Classes',
            route: '/admin/classes',
            parent: 'Setup',
            order: 3,
            icon: null,
            parent_icon: null,
            display: 1,
        },
        {
            name: 'streams',
            custom_name: 'Streams',
            route: '/admin/streams',
            parent: 'Setup',
            order: 3,
            icon: null,
            parent_icon: null,
            display: 1,
        },
        {
            name: 'accommodation',
            custom_name: 'Accommodation',
            route: '/admin/accommodation',
            parent: 'Setup',
            order: 3,
            icon: null,
            parent_icon: null,
            display: 1,
        },
        {
            name: 'preschool_learning_areas',
            custom_name: 'Preschool Learning Areas',
            route: '/admin/preschool_learning_areas',
            parent: 'Setup',
            order: 3,
            icon: null,
            parent_icon: null,
            display: 1,
        },
        {
            name: 'preschool_grades',
            custom_name: 'Preschool Grades',
            route: '/admin/preschool_grades',
            parent: 'Setup',
            order: 3,
            icon: null,
            parent_icon: null,
            display: 1,
        },
        {
            name: 'attendance_remarks',
            custom_name: 'Attendance Remarks',
            route: '/admin/attendance_remarks',
            parent: 'Setup',
            order: 3,
            icon: null,
            parent_icon: null,
            display: 1,
        },



        //ACADEMICS
        {
            name: 'assign_subject',
            custom_name: 'Assign Subjects',
            route: '/admin/assign_subjects',
            parent: 'Academics',
            order: 4,
            icon: null,
            parent_icon: 'fas fa-graduation-cap',
            display: 1,
        },
        {
            name: 'my_scoresheet',
            custom_name: 'My Subjects',
            route: '/admin/my_subjects',
            parent: 'Academics',
            order: 4,
            icon: null,
            parent_icon: 'fas fa-graduation-cap',
            display: 1,
        },
        {
            name: 'my_scoresheet',
            custom_name: 'Class Subjects',
            route: '/admin/class_subjects',
            parent: 'Academics',
            order: 4,
            icon: null,
            parent_icon: 'fas fa-graduation-cap',
            display: 1,
        },
        {
            name: 'students',
            custom_name: 'Students',
            route: '/admin/students',
            parent: 'Academics',
            order: 4,
            icon: null,
            parent_icon: 'fas fa-graduation-cap',
            display: 1,
        },
        {
            name: 'nursery_assessment_entry',
            custom_name: 'Nursery Assessment',
            route: '/admin/nursery_assessment_entry',
            parent: 'Academics',
            order: 4,
            icon: null,
            parent_icon: 'fas fa-graduation-cap',
            display: 0,
        },
        {
            name: 'primary_assessment_entry',
            custom_name: 'Primary Assessments',
            route: '/admin/primary_assessment_entry',
            parent: 'Academics',
            order: 4,
            icon: null,
            parent_icon: 'fas fa-graduation-cap',
            display: 0,
        },
        {
            name: 'primary_assessment_review',
            custom_name: 'Primary Assessment Review',
            route: '/admin/primary_assessment_review',
            parent: 'Academics',
            order: 4,
            icon: null,
            parent_icon: 'fas fa-graduation-cap',
            display: 1
        },
        {
            name: 'primary_assessment_publish',
            custom_name: 'Primary Assessment Publish',
            route: '/admin/primary_assessment_publish',
            parent: 'Academics',
            order: 4,
            icon: null,
            parent_icon: 'fas fa-graduation-cap',
            display: 1
        },
        {
            name: 'nursery_assessment_review',
            custom_name: 'Nursery Assessment Review',
            route: '/admin/nursery_assessment_review',
            parent: 'Academics',
            order: 4,
            icon: null,
            parent_icon: 'fas fa-graduation-cap',
            display: 1
        },
        {
            name: 'nursery_assessment_publish',
            custom_name: 'Nursery Assessment Publish',
            route: '/admin/nursery_assessment_publish',
            parent: 'Academics',
            order: 4,
            icon: null,
            parent_icon: 'fas fa-graduation-cap',
            display: 1
        },
        {
            name: 'attendance',
            custom_name: 'Attendance',
            route: '/admin/attendance',
            parent: 'Academics',
            order: 4,
            icon: null,
            parent_icon: 'fas fa-graduation-cap',
            display: 0,
        },



        // {
        //     name: 'assign_subject',
        //     custom_name: 'Assign Subject',
        //     route: '/admin/streams',
        //     parent: 'Academics',
        //     order: 4,
        //     icon: null,
        //     parent_icon: 'fas fa-graduation-cap',
        //     display: 1,
        // },

        // {
        //     name: 'dashboard',
        //     custom_name: 'Dashboard',
        //     route: '/applicant/dashboard',
        //     parent: null,
        //     order: 1,
        //     icon: 'fas fa-tachometer-alt',
        //     parent_icon: null,
        //     display: 1,
        // },

        // {
        //     name: 'form',
        //     custom_name: 'Student Application',
        //     route: '/applicant/form',
        //     parent: null,
        //     order: 2,
        //     icon: 'fas fa-file-alt',
        //     parent_icon: null,
        //     display: 0,
        // },


        {
            name: 'allocation',
            custom_name: 'Boarding Allocation',
            route: '/admin/boarding_allocation',
            parent: 'Online Admissions',
            order: 4,
            icon: null,
            parent_icon: 'fas fa-user-shield',
            display: 1,
        },


        // {
        //     name: 'draft',
        //     custom_name: 'Draft',
        //     route: '/admin/draft',
        //     parent: 'Online Admissions',
        //     order: 4,
        //     icon: null,
        //     parent_icon: 'fas fa-user-shield',
        //     display: 1,
        // },
        // {
        //     name: 'pending',
        //     custom_name: 'Pending',
        //     route: '/admin/pending',
        //     parent: 'Online Admissions',
        //     order: 4,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'verified',
        //     custom_name: 'Verified',
        //     route: '/admin/verified',
        //     parent: 'Online Admissions',
        //     order: 4,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },


        // {
        //     name: 'approved',
        //     custom_name: 'Approved',
        //     route: '/admin/approved',
        //     parent: 'Online Admissions',
        //     order: 4,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'admitted',
        //     custom_name: 'Admitted',
        //     route: '/admin/admitted',
        //     parent: 'Online Admissions',
        //     order: 4,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },


        // {
        //     name: 'rejected',
        //     custom_name: 'Rejected',
        //     route: '/admin/rejected',
        //     parent: 'Online Admissions',
        //     order: 4,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },

        // {
        //     name: 'students',
        //     custom_name: 'Student Records',
        //     route: '/admin/students',
        //     parent: 'Academics',
        //     order: 6,
        //     icon: null,
        //     parent_icon: 'fas fa-graduation-cap',
        //     display: 1,
        // },
        // {
        //     name: 'timettable',
        //     custom_name: 'Time Table',
        //     route: '/admin/timettable',
        //     parent: 'Academics',
        //     order: 6,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'grading',
        //     custom_name: 'Grading',
        //     route: '/admin/grading',
        //     parent: 'Academics',
        //     order: 6,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },

        // {
        //     name: 'bus_tracking',
        //     custom_name: 'Bus Tracking',
        //     route: '/admin/bus_tracking',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: 'fas fa-map-marker',
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'buses',
        //     custom_name: 'Buses',
        //     route: '/admin/buses',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'drivers',
        //     custom_name: 'Drivers',
        //     route: '/admin/drivers',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },
        // {
        //     name: 'routes',
        //     custom_name: 'Routes',
        //     route: '/admin/routes',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },
        // {
        //     name: 'driver_bus_routes',
        //     custom_name: 'Driver Bus Routes',
        //     route: '/admin/driver_bus_routes',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },

        // {
        //     name: 'busstops',
        //     custom_name: 'Bus stops',
        //     route: '/admin/bus_stops',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },

        // {
        //     name: 'transport_types',
        //     custom_name: 'Transport Types',
        //     route: '/admin/transport_types',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },
        // {
        //     name: 'transport_tariffs',
        //     custom_name: 'Transport Tariffs',
        //     route: '/admin/transport_tariffs',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },
        // {
        //     name: 'coupons',
        //     custom_name: 'Fuel Coupons',
        //     route: '/admin/generated_fuel_coupons',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },
        // {
        //     name: 'my_fuel_requests',
        //     custom_name: 'My Fuel Requests',
        //     route: '/admin/my_fuel_requests',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },
        // {
        //     name: 'fuel_requests_L1',
        //     custom_name: 'New Fuel Requests',
        //     route: '/admin/pending_L1_approval',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },
        // {
        //     name: 'fuel_requests_L2',
        //     custom_name: 'Pending L2 Fuel',
        //     route: '/admin/pending_L2_approval',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },
        // {
        //     name: 'all_fuel_requests',
        //     custom_name: 'All Fuel Requests',
        //     route: '/admin/all_fuel_requests',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },
        // {
        //     name: 'my_maintenance_requests',
        //     custom_name: 'My Maintenance',
        //     route: '/admin/my_maintenance_requests',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },
        // {
        //     name: 'pending_maintenance_requests',
        //     custom_name: 'Pending Maintenance',
        //     route: '/admin/pending_maintenance_requests',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },
        // {
        //     name: 'all_maintenance_requests',
        //     custom_name: 'All Maintenance',
        //     route: '/admin/all_maintenance_requests',
        //     parent: 'Transport',
        //     order: 7,
        //     icon: null,
        //     parent_icon: 'fas fa-bus',
        //     display: 1,
        // },


        // {
        //     name: 'receipts',
        //     custom_name: 'Transactions & Receipts',
        //     route: '/admin/receipt',
        //     parent: 'Finance',
        //     order: 8,
        //     icon: null,
        //     parent_icon: 'fas fa-wallet',
        //     display: 1,
        // }, 
        // {
        //     name: 'payments',
        //     custom_name: 'Payments',
        //     route: '/admin/payments',
        //     parent: 'Finance',
        //     order: 8,
        //     icon: null,
        //     parent_icon: 'fas fa-wallet',
        //     display: 1,
        // }, {
        //     name: 'billing',
        //     custom_name: 'Billing',
        //     route: '/admin/billing',
        //     parent: 'Finance',
        //     order: 8,
        //     icon: null,
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'settings',
        //     custom_name: 'Settings',
        //     route: '/admin/settings',
        //     parent: null,
        //     order: 11,
        //     icon: 'fas fa-cog',
        //     parent_icon: null,
        //     display: 1,
        // },
        // {
        //     name: 'audit',
        //     custom_name: 'Audit Trail',
        //     route: '/admin/audit',
        //     parent: null,
        //     order: 10,
        //     icon: 'fas fa-book',
        //     parent_icon: null,
        //     display: 1,
        // },
    ],*/

  /*nationality: [
        { "country": "Afghanistan", "nationality": "Afghan" },
        { "country": "Albania", "nationality": "Albanian" },
        { "country": "Algeria", "nationality": "Algerian" },
        { "country": "Argentina", "nationality": "Argentinian" },
        { "country": "Australia", "nationality": "Australian" },
        { "country": "Austria", "nationality": "Austrian" },
        { "country": "Bangladesh", "nationality": "Bangladeshi" },
        { "country": "Belgium", "nationality": "Belgian" },
        { "country": "Brazil", "nationality": "Brazilian" },
        { "country": "Canada", "nationality": "Canadian" },
        { "country": "China", "nationality": "Chinese" },
        { "country": "Denmark", "nationality": "Danish" },
        { "country": "Egypt", "nationality": "Egyptian" },
        { "country": "France", "nationality": "French" },
        { "country": "Germany", "nationality": "German" },
        { "country": "Ghana", "nationality": "Ghanaian" },
        { "country": "India", "nationality": "Indian" },
        { "country": "Indonesia", "nationality": "Indonesian" },
        { "country": "Italy", "nationality": "Italian" },
        { "country": "Japan", "nationality": "Japanese" },
        { "country": "Kenya", "nationality": "Kenyan" },
        { "country": "Mexico", "nationality": "Mexican" },
        { "country": "Netherlands", "nationality": "Dutch" },
        { "country": "Nigeria", "nationality": "Nigerian" },
        { "country": "Norway", "nationality": "Norwegian" },
        { "country": "Pakistan", "nationality": "Pakistani" },
        { "country": "Russia", "nationality": "Russian" },
        { "country": "Saudi Arabia", "nationality": "Saudi" },
        { "country": "South Africa", "nationality": "South African" },
        { "country": "South Korea", "nationality": "South Korean" },
        { "country": "Spain", "nationality": "Spanish" },
        { "country": "Sweden", "nationality": "Swedish" },
        { "country": "Switzerland", "nationality": "Swiss" },
        { "country": "Thailand", "nationality": "Thai" },
        { "country": "Turkey", "nationality": "Turkish" },
        { "country": "Uganda", "nationality": "Ugandan" },
        { "country": "Ukraine", "nationality": "Ukrainian" },
        { "country": "United Kingdom", "nationality": "British" },
        { "country": "United States", "nationality": "American" },
        { "country": "Vietnam", "nationality": "Vietnamese" },
        { "country": "Zimbabwe", "nationality": "Zimbabwean" }
    ],*/

  setArray: (key, value) => {
    // set((state) => ({
    //     [key]: [...state[key], ...value]
    // }));
    set((state) => {
      const newValue = [...state[key], ...value];
      sessionStorage.setItem(key, JSON.stringify(newValue));
      return { [key]: newValue };
    });
  },
  setValue: (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value));
    set((state) => ({ [key]: value }));
  },
  getArrayObjectsValue: (stateKey, searchKey, value) => {
    //returns a single item
    const state = get(); //zustand get callback function
    const record =
      state[stateKey] || JSON.parse(sessionStorage.getItem(stateKey) || "{}");
    let val = {};
    if (Array.isArray(record)) {
      record?.forEach((v) => {
        if (v[searchKey] === value) {
          val = v;
        }
      });
    }
    return val;
  },
  getValue: (key) => {
    const state = get();
    return state[key] || JSON.parse(sessionStorage.getItem(key) || "{}");
  },
  getValuesBy: (stateKey, searchKey, value) => {
    //returns an array
    const state = get(); //zustand get callback function
    const record =
      state[stateKey] || JSON.parse(sessionStorage.getItem(stateKey) || "{}");
    let val = [];
    if (Array.isArray(record)) {
      record?.forEach((v) => {
        if (v[searchKey] === value) {
          val.push(v);
        }
      });
    }
    return val;
  },
  updateObjectValue: (stateKey, whereKey, value) => {
    set((state) => {
      const record = { ...state[stateKey] };
      record[whereKey] = value;
      sessionStorage.setItem(stateKey, JSON.stringify(record));
      return { [stateKey]: record };
    });
  },
  updateValue: (stateKey, whereKey, whereValue, newValue) => {
    set((state) => {
      const record = state[stateKey];
      let newState = [...record];
      newState &&
        newState?.forEach((v, i) => {
          if (v[whereKey] === whereValue) {
            newState[i] = newValue;
          }
        });
      sessionStorage.setItem(stateKey, JSON.stringify(newState));
      return { [stateKey]: newState };
    });
  },
  updateArrayObjectValue: (
    stateKey,
    whereKey,
    whereValue,
    itemKey,
    newValue,
  ) => {
    set((state) => {
      const record = state[stateKey];
      let newState = [...record];
      newState &&
        newState?.forEach((v, i) => {
          if (v[whereKey] === whereValue) {
            newState[i][itemKey] = newValue;
          }
        });
      sessionStorage.setItem(stateKey, JSON.stringify(newState));
      return { [stateKey]: newState };
    });
  },
  deleteValue: (stateKey) => {
    set((state) => {
      sessionStorage.removeItem(stateKey);
      let newState = { ...state };
      delete newState[stateKey];
      return newState;
    });
  },
  deleteObjectValue: (stateKey, whereKey) => {
    set((state) => {
      sessionStorage.removeItem(stateKey);
      const record = state[stateKey];
      let newState = { ...record };
      delete newState[whereKey];
      return { [stateKey]: newState };
    });
  },
  resetAuthState: () => {
    AUTH_STORAGE_KEYS.forEach((key) => sessionStorage.removeItem(key));
    set(() => ({ ...AUTH_STATE_DEFAULTS }));
  },
});

export const useStore = create(devtools(store));

const useTrackedStore = createTrackedSelector(useStore);
export default useTrackedStore;
export const resetAuthStore = () => useStore.getState().resetAuthState?.();
